/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ISchemaConstBooleanModel, isSchemaConstBooleanModel } from "@adapptio/lib-blueprint";
import { IInspectorControl_Boolean, INSPECTOR_CONTROL_TYPE } from "../controls";
import { INSPECTOR_NODE_TYPE, TInspectorNode } from "../InspectorNodeTypes";
import { mapperDescriptor } from "../../modules/Core/ReferenceGuide/mappers/mapperDescriptor";
import { mapperExamples } from "../../modules/Core/ReferenceGuide/mappers/mapperExamples";
import { getParentComponentName } from "../utils";

export function constBooleanMapper(model: ISchemaConstBooleanModel): TInspectorNode {
	if (!isSchemaConstBooleanModel(model)) {
		return;
	}

	const control: IInspectorControl_Boolean = {
		key: String(model.nodeId),
		type: INSPECTOR_CONTROL_TYPE.BOOLEAN,
		model
	};

	return {
		type: INSPECTOR_NODE_TYPE.DEFAULT,
		key: `${model.nodeId}`,
		label: model.schema.opts.label,
		required: model.schema.opts.constraints?.required || false,
		options: model.schema.opts["options"],
		default: model.schema.opts.default || null,
		referenceData: getParentComponentName(model),
		descriptor: mapperDescriptor(model.schema),
		examples: mapperExamples(model.schema),
		tooltip: model.schema.opts.description,
		deps: [ model ],
		controls: [ control ],
		children: []
	};
}
